import { topicTags } from '@/mocks/home';

export default function TopicWall() {
  return (
    <section id="topics" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5 lg:gap-10">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.24em] text-accent-600">
              <span className="w-6 h-px bg-accent-400" />
              TOPIC WALL
            </span>
            <h2 className="mt-4 font-heading font-black text-foreground-950 text-3xl md:text-4xl tracking-tight">
              话题墙
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              所有讨论都挂在这面墙上。点一个标签，就能看到围绕灵灵黑料深扒细节展开的
              原帖、截图与各方说法，按热度从高到低排。
            </p>
          </div>
          <div className="flex items-center gap-6 shrink-0">
            <div>
              <div className="font-heading font-black text-2xl md:text-3xl text-foreground-950">16</div>
              <div className="text-xs font-label text-foreground-500 mt-1">个活跃话题</div>
            </div>
            <div className="w-px h-12 bg-background-300" />
            <div>
              <div className="font-heading font-black text-2xl md:text-3xl text-foreground-950">2.9万</div>
              <div className="text-xs font-label text-foreground-500 mt-1">条相关讨论</div>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-14 flex flex-wrap gap-3 md:gap-3.5">
          {topicTags.map((t, idx) => (
            <a
              key={t.id}
              href="#posts"
              style={{ animationDelay: `${idx * 30}ms` }}
              className={`group flex items-center gap-2.5 px-4 md:px-5 py-3 rounded-lg border transition-colors ll-fade-up ${
                t.hot
                  ? 'bg-accent-50 border-accent-200 hover:bg-accent-100'
                  : 'bg-background-100 border-background-200 hover:bg-background-200'
              }`}
            >
              <span
                className={`font-label text-sm md:text-[15px] whitespace-nowrap ${
                  t.hot ? 'text-accent-800 font-medium' : 'text-foreground-800'
                }`}
              >
                #{t.label}
              </span>
              <span
                className={`text-xs font-label px-2 py-0.5 rounded-full whitespace-nowrap ${
                  t.hot ? 'bg-accent-200/70 text-accent-800' : 'bg-background-50 text-foreground-500'
                }`}
              >
                {t.count}
              </span>
              {t.hot && <i className="ri-fire-line text-accent-500 text-sm" />}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}